import api from './api';

// Get all permissions with optional filters
export const getPermissions = async (params = {}) => {
  // Если не указан параметр all, используем пагинацию
  const queryParams = { ...params };
  const response = await api.get('/api/permissions', { params: queryParams });
  return response.data;
};

// Get permissions grouped by service
export const getPermissionsByService = async () => {
  const response = await api.get('/api/permissions/by-service');
  return response.data;
};



// Get user permissions
export const getUserPermissions = async (userId) => {
  console.log('📡 API: getUserPermissions called with userId:', userId);
  try {
    const response = await api.get(`/api/users/${userId}/permissions`);
    
    // Backend возвращает {permissions: [array]}, но нам нужен массив напрямую
    return response.data.permissions || [];
  } catch (error) {
    console.error('📡 API: getUserPermissions error:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data
    });
    throw error;
  }
};

// Check if user has specific permission
export const checkUserPermission = async (userId, service, resource, action) => {
  const response = await api.post('/api/permissions/check', {
    userId,
    service,
    resource,
    action
  });
  return response.data;
};

// Get available services
export const getAvailableServices = async (params = {}) => {
  const response = await api.get('/api/permissions/services', { params });
  return response.data.services || [];
};

// Get available resources. `service` can be a string or an array of services.
export const getAvailableResources = async (service = null, params = {}) => {
  const queryParams = { all: true, ...params };
  if (Array.isArray(service)) {
    if (service.length > 0) queryParams.service = service;
  } else if (service) {
    queryParams.service = service;
  }
  const response = await api.get('/api/permissions/resources', { params: queryParams });
  return response.data.resources || [];
};

// Get available actions. Accepts optional service/resource arrays in params for cascading.
export const getAvailableActions = async (params = {}) => {
  const response = await api.get('/api/permissions/actions', { params });
  return response.data.actions || [];
};

// Update permission status (isActive)
export const updatePermissionStatus = async (permissionId, isActive) => {
  const response = await api.patch(`/api/permissions/${permissionId}/status`, { isActive });
  return response.data;
};

// Create wildcard permission
export const createWildcardPermission = async (service, resource, action = '*') => {
  const response = await api.post('/api/permissions/wildcard', { service, resource, action });
  return response.data;
};

// Sync permissions with configuration
export const syncPermissions = async () => {
  const response = await api.post('/api/permissions/sync');
  return response.data;
};


// Create a new permission
export const createPermission = async ({ name, description, service, resource, action, conditions = {} }) => {
  const payload = { name, description, service, resource, action, conditions };
  const response = await api.post('/api/permissions', payload);
  return response.data;
};

// Delete (soft delete) a permission
export const deletePermission = async (permissionId) => {
  const response = await api.delete(`/api/permissions/${permissionId}`);
  return response.data;
};

// Bulk delete permissions
export const bulkDeletePermissions = async (ids) => {
  const response = await api.post('/api/permissions/bulk/delete', { ids });
  return response.data;
};

// Bulk update isActive for permissions
export const bulkUpdatePermissionStatus = async ({ ids, isActive }) => {
  const response = await api.patch('/api/permissions/bulk/status', { ids, isActive });
  return response.data;
};



